/*
 * Shimmering text, ported from Animate UI (https://animate-ui.com), MIT + Commons Clause,
 * Copyright (c) 2025 Elliot Sutton. See THIRD_PARTY_NOTICES.md.
 */
import { motion } from "framer-motion";
import { motionAllowed } from "./motionEnv";

export default function ShimmeringText({ text, duration = 1.2, color = "currentColor", shimmeringColor = "#8FD3A6", className = "" }) {
  if (!motionAllowed()) return <span className={className}>{text}</span>;
  return (
    <span className={className} aria-label={text} style={{ "--c": color, "--s": shimmeringColor, display: "inline-block" }}>
      {text.split("").map((ch, i) => (
        <motion.span
          key={i}
          aria-hidden="true"
          style={{ display: "inline-block", whiteSpace: "pre" }}
          initial={{ color: "var(--c)" }}
          animate={{ color: ["var(--c)", "var(--s)", "var(--c)"] }}
          transition={{ duration, repeat: Infinity, repeatType: "loop", repeatDelay: text.length * 0.05, delay: (i * duration) / text.length, ease: "easeInOut" }}
        >
          {ch}
        </motion.span>
      ))}
    </span>
  );
}
